import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import Quill from 'quill';

// Uses the same Quill engine as Mail, without ReactDOM.findDOMNode (removed in React 19).
const MailRichEditor = forwardRef(function MailRichEditor({value, readOnly, onChange, onChangeSelection, onFocus, modules, formats}, ref) {
  const host = useRef(null), editor = useRef(null), callbacks = useRef({});
  callbacks.current = {onChange, onChangeSelection, onFocus};
  const initial = useRef({value, modules, formats});
  useImperativeHandle(ref, () => ({getEditor: () => editor.current}), []);
  useEffect(() => {
    const node = document.createElement('div'); host.current.appendChild(node);
    const q = new Quill(node, {theme:'snow', modules:initial.current.modules, formats:initial.current.formats});
    editor.current=q;
    q.setContents(q.clipboard.convert(initial.current.value || ''), 'silent');
    q.root.setAttribute('role','textbox'); q.root.setAttribute('aria-label','Message'); q.root.setAttribute('aria-multiline','true');
    const change = () => callbacks.current.onChange?.(q.root.innerHTML);
    const selection = range => {callbacks.current.onChangeSelection?.(range); if(range)callbacks.current.onFocus?.();};
    q.on('text-change',change); q.on('selection-change',selection);
    const container=host.current;
    return () => {q.off('text-change',change);q.off('selection-change',selection);editor.current=null;container.replaceChildren();};
  }, []);
  useEffect(() => {const q=editor.current;if(q && q.root.innerHTML !== value){const range=q.getSelection();q.setContents(q.clipboard.convert(value||''),'silent');if(range)q.setSelection(Math.min(range.index,Math.max(0,q.getLength()-1)),0,'silent');}},[value]);
  useEffect(() => {editor.current?.enable(!readOnly);},[readOnly]);
  return <div ref={host} className="quill"/>;
});
export default MailRichEditor;
